import { useState, useEffect } from 'react';

/**
 * ウィンドウサイズを取得するためのカスタムフック
 *
 * @returns ウィンドウの幅と高さ
 */
export function useWindowSize(): { width: number; height: number } {
  // 初期値はSSRでのエラーを防ぐために0に設定
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0
  });

  useEffect(() => {
    // ブラウザ環境でのみ実行
    if (typeof window === 'undefined') {
      return;
    }

    // ウィンドウサイズを更新する関数
    function handleResize(): void {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    // 初期サイズを設定
    handleResize();

    // リサイズイベントリスナーを追加
    window.addEventListener('resize', handleResize);

    // クリーンアップ関数
    return (): void => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
